// extracted by mini-css-extract-plugin
export default {"link":"VBLink_link__wHMIU","noStyle":"VBLink_noStyle__b2Yk3"};